import { icons } from 'src/assets/iconDef/icon.def';

export const aiMlGatewayMenuDef = [
  {
    name: 'menu.ai_prompt_limit',
    resource: 'ai_prompt_limit',
    icon: icons.list.horizontalList,
    url: 'ai_prompt_limit',
    auto_crud: true
  },
  {
    name: 'menu.ai_prompt_master',
    resource: 'ai_prompt_master',
    icon: icons.list.horizontalList,
    url: 'ai_prompt_master',
    auto_crud: true
  },
  {
    name: 'menu.ai_agent_master',
    resource: 'ai_agent_master',
    icon: icons.list.horizontalList,
    url: 'ai_agent_master',
    auto_crud: true 
  },
  {
    name: 'menu.ai_feature_master',
    resource: 'ai_feature_master',
    icon: icons.list.horizontalList,
    url: 'ai_feature_master',
    auto_crud: true 
  },
  {
    name: 'menu.ai_model_master',
    resource: 'ai_model_master',
    icon: icons.list.horizontalList,
    url: 'ai_model_master',
    auto_crud: true
  },
  {
    name: 'menu.ai_applications',
    resource: 'ai_applications',
    icon: icons.list.horizontalList,
    url: 'ai_applications',
    auto_crud: true
  },
  // The event catalog agent triggers are built on (Agent Studio's guided wizard, Triggers step).
  {
    name: 'menu.ai_application_event',
    resource: 'ai_application_event',
    icon: icons.list.horizontalList,
    url: 'ai_application_event',
    auto_crud: true
  },
  {
    name: 'menu.ai_agent_registry',
    resource: 'ai_agent_registry',
    icon: icons.list.horizontalList,
    url: 'ai_agent_registry',
    auto_crud: true
  },
  // The nav item comes from menu master (APPLICATION_AWARE: the sidebar is the server's
  // menu); this entry only gives aiml-gateway/ai_knowledge_base its auto-CRUD route.
  {
    name: 'menu.ai_knowledge_base',
    resource: 'ai_knowledge_base',
    icon: icons.list.horizontalList,
    url: 'ai_knowledge_base',
    auto_crud: true
  },
  // NOTE: `ai_audit_logs` is deliberately NOT listed here. It already has a menu
  // entry under account-management, and one resource in two menus is the same
  // screen twice in the nav with no RBAC difference — the rights are per
  // resource, not per menu. AI spend is read there.
  // KX Insights access log — who read what, and when. Pure JSON: the grid, its
  // filters and its paging are the platform's generic ui_engine reading the
  // `bi_query_audit` resource directly. There is no Angular component and no
  // bespoke read API behind it, which is the whole point of routing the write
  // through the gateway rather than keeping the collection private to Python.
  //
  // Read-only by construction: the resource offers only `view`, and
  // BiQueryAuditDecorator refuses add/modify/delete outright — an access log a
  // user can edit is not an access log. Grant its `view`/`GET_PAGE` rights to a
  // compliance/admin role only: unlike every other screen here, it shows one
  // user another user's activity.
  // Business metadata for the KX Insights catalog — owner, description, tags,
  // certification. Pure JSON: schema discovery already knows every table and
  // column, and this is the half a PERSON has to write down. Usage counts
  // ("used by N dashboards") are NOT edited here — they are derived on read by
  // routes/bi/lineage.py, because a stored count goes stale.
  {
    name: 'menu.bi_catalog_asset',
    resource: 'bi_catalog_asset',
    icon: icons.list.horizontalList,
    url: 'bi_catalog_asset',
    auto_crud: true
  },
  {
    name: 'menu.bi_query_audit',
    resource: 'bi_query_audit',
    icon: icons.list.horizontalList,
    url: 'bi_query_audit',
    auto_crud: true
  }
]
